import { HYPHEN_MINUS } from '@dealstack/frontend/shared/other/react/specialSigns';
import { numericFormatter } from 'react-number-format';

// The rest of the platform's number rendering lives in `@dealstack/shared/lib/format/number`,
// which generated documents also read. This one stays here: `react-number-format` is a React
// package and has no business in the server-side bundle.
export const numberToCost = (number: number | null) => {
	if (number == null) {
		return HYPHEN_MINUS;
	}
	return numericFormatter(number.toString(), {
		displayType: 'text',
		thousandSeparator: true,
		decimalScale: 2,
		fixedDecimalScale: true,
	});
};
